module.exports = __webpack_public_path__ + "static/img/usc_mobile_badge.f6498ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/usc_mobile_badge.svg
// module id = VPos
// module chunks = 1